import store from '@/renderer/store';
import router from '@/renderer/router';
import { SMH } from '@/renderer/scripts/smh';
import i18n, { i18n_t } from '@/locales/i18n';

type ChannelInfo = {
  channelTag: SMH.ChannelTag;
  channelName: string;
  channelIconClass: 'wemeet-icon' | 'auth-space' | string;
};

const channelIconMap: Record<string, string> = {
  meeting: 'wemeet-icon',
  hiflow: 'auth-space',
};

const channelNameMap: Record<string, string> = {
  meeting: i18n_t('会议'),
  hiflow: 'hiflow',
  vistor: i18n_t('游客'),
};

// hiflow更名为腾讯轻联
export const channelEditionMap: Record<string, string> = {
  meeting: i18n_t('会议体验版'),
  hiflow: i18n_t('轻联体验版'),
  vistor: i18n_t('游客体验版'),
  'official-free': i18n_t('免费试用版'),
};

/**
 * 获取当前渠道:meeting | hiflow
 * 会议里通过会议环境判断
 * hiflow通过登录页的路由query里的channel_flag判断
 */

export function getChannel(isVistor?: boolean): ChannelInfo {
  let channelTag = '';
  const { query } = router.currentRoute;
  const isOauth2 = checkIsOauth2();
  if (store.getters.isInWeMeetApp) {
    channelTag = 'meeting';
  } else if (isOauth2 && query?.channel_flag === 'hiflow') {
    channelTag = 'hiflow';
  } else if (isVistor) {
    channelTag = 'visitor';
  }
  const channelName = channelNameMap[channelTag];
  const channelIconClass = channelIconMap[channelTag];
  return { channelTag, channelName, channelIconClass };
}

// 是否oauth2页面
export function checkIsOauth2(): boolean {
  const { name, query } = router.currentRoute;
  const isOauth2 = (name === 'login' && query.oauth2 === '1') || name === 'oauth2';
  return isOauth2;
}
